import { Routes } from '@angular/router';
import { NotFoundPageComponent } from '@/core/http/pages/not-found-page/not-found-page.component';
// import { QrGuard } from '@/core/qr/guards/qr.guard';

export const routes: Routes = [
  {
    path: '',
    children: [
      // Catalogue
      {
        path: 'carta',
        // canActivate: [QrGuard],
        loadChildren: () => import('@/features/catalog/catalog.routes'),
      },

      // Cart
      {
        path: 'mi-orden',
        loadChildren: () => import('@/features/cart/cart.routes'),
      },

      // Checkout
      {
        path: 'datos',
        loadChildren: () => import('@/features/checkout/checkout.routes'),
      },

      // Home redirect to Catalogue
      {
        path: '',
        redirectTo: 'carta',
        pathMatch: 'full',
      },

      // Unhandled routes (404)
      {
        path: '**',
        component: NotFoundPageComponent,
      },
    ],
  },
];
